import loginService from "./services/login";

export const signOutUser = async (access_token: string, id_token: string) => {
  const revokeTokenResp = await loginService.revokeAccessToken(access_token);
  const logoutURL = await loginService.generateLogoutURL(id_token);
  window.open(logoutURL, "_self");
};
